export default __webpack_public_path__ + "static/7-ae9da134554de678275399e67fb0229a.png";